import { render, staticRenderFns } from "./GuideCard.vue?vue&type=template&id=18d10ed6&"
import script from "./GuideCard.vue?vue&type=script&lang=js&"
export * from "./GuideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports